import React from 'react'
import hintIcon from 'Shared/img/svg/question.svg'
import { StyledHint } from './HintGuide.styled'

export interface HintGuideProps {
  content?: string
  hintName: string
  setHintName: (hintName: string) => void
  onClick?: (e?: React.MouseEvent) => void
  currentHint: string | null
}

export const HintGuideStorybook: React.FC<HintGuideProps> = ({
  hintName = '',
  setHintName,
  currentHint,
  ...props
}) => {
  const handleClick = () => {
    if (currentHint === hintName) {
      setHintName('clearHint')
    } else setHintName(hintName)
  }

  return (
    <>
      <StyledHint onClick={() => handleClick()} {...props}>
        <img src={hintIcon} alt="FAQ" />
      </StyledHint>
    </>
  )
}
